import { ChangeEvent } from "react";
import { TranslationKey } from "../../../../shared/i18n/i18n";
import { FieldVisibility } from "../../common/FieldVisibilityIcon";
import { AdminDetailLabel } from "./AdminDetailLabel";

type AdminQuotaLimitFieldProps = {
  currentValue: string;
  currentValueStatus?: "exceeded" | "within";
  isLimitReadOnly: boolean;
  label: string;
  limitValue: string;
  onLimitChange?: (value: string) => void;
  t: (key: TranslationKey) => string;
  visibility: FieldVisibility;
};

export const AdminQuotaLimitField = ({
  currentValue,
  currentValueStatus,
  isLimitReadOnly,
  label,
  limitValue,
  onLimitChange,
  t,
  visibility,
}: AdminQuotaLimitFieldProps) => {
  const handleLimitChange = onLimitChange
    ? (event: ChangeEvent<HTMLInputElement>) => onLimitChange(event.target.value)
    : undefined;

  return (
    <label className="admin-detail-field">
      <AdminDetailLabel
        label={label}
        t={t}
        visibility={visibility}
      />
      <div className="admin-detail-quota-limit-row">
        <input
          aria-label={`${label} ${t("admin.subscription.currentAmount")}`}
          className={`admin-detail-input admin-detail-quota-limit-input${currentValueStatus ? ` is-${currentValueStatus}` : ""}`}
          readOnly
          type="text"
          value={currentValue}
        />
        <span className="admin-detail-quota-limit-separator">/</span>
        <input
          aria-label={`${label} ${t("admin.subscription.limitAmount")}`}
          className="admin-detail-input admin-detail-quota-limit-input"
          onChange={handleLimitChange}
          readOnly={isLimitReadOnly}
          type="text"
          value={limitValue}
        />
      </div>
    </label>
  );
};
